import { useEffect, useState } from 'react';

import {
  CreationAccountMeasure,
  CreationAccountRow,
  GetCreationAccountMeasuresOrderEnum,
  GetCreationAccountMeasuresRowsEnum,
  PatchMeasureInput,
  PostCreationAccountInput,
  PostMeasureInput,
  SnsType,
} from '@/api/creation';
import {
  getCreationAccountMeasures,
  getCreationAccounts,
  patchMeasure,
  postCreationAccount,
  postMeasure,
} from '@/hooks/Creation';

import { AccountView } from './AccountView';
import { ProjectListView } from './ProjectListView';

export const ManagementView = () => {
  const [accounts, setAccounts] = useState<CreationAccountRow[]>([]);
  const [selectAccount, setSelectAccount] = useState<CreationAccountRow>({
    id: '',
    snsType: SnsType.Other,
    name: '',
  });
  const [measures, setMeasures] = useState<CreationAccountMeasure[]>([]);
  const [totalRows, setTotalRows] = useState<number>(0);
  const updateMeasures =
    (accountId: string) =>
    (
      perPage?: GetCreationAccountMeasuresRowsEnum,
      currentPage?: number,
      order?: GetCreationAccountMeasuresOrderEnum,
      orderBy?: string
    ) => {
      if (accountId === '') return;
      getCreationAccountMeasures(accountId, perPage, currentPage, order, orderBy).then((response) => {
        setTotalRows(response.totalRows);
        setMeasures(response.rows);
      });
    };
  const addAccount = async (input: PostCreationAccountInput) => {
    const response = await postCreationAccount(input);
    const accounts = await getCreationAccounts();
    const newAccount = accounts.find((account) => account.id === response.affected);
    setAccounts(accounts);
    newAccount && setSelectAccount(newAccount);
  };
  const addMeasure = (accountId: string) => (input: PostMeasureInput) => {
    return postMeasure(accountId, input);
  };
  const editMeasure = (measureId: string, input: PatchMeasureInput) => {
    return patchMeasure(measureId, input);
  };

  useEffect(() => {
    (async () => {
      const accounts = await getCreationAccounts();
      const selectAccount = accounts.length ? accounts[0] : null;
      setAccounts(accounts);
      if (selectAccount) {
        setSelectAccount(selectAccount);
        updateMeasures(selectAccount.id)(10, 1, 'desc');
      }
    })();
  }, []);

  return (
    <>
      <div className="w-full max-w-[1181px] bg-gray-50">
        <div className="w-full border-b border-gray-200 p-[16px]">
          <p className="text-base font-semibold leading-7 text-gray-700">PRST(制作案件) 投稿制作管理一覧</p>
        </div>
        <div className="flex bg-gray-50">
          <div className="ml-[5px] mt-[3px] w-[236px] border-r border-gray-200 pt-[24px]">
            <p className="ml-[16px] h-[16px] w-[98px] text-sm font-medium leading-4 text-[#000000]">アカウント一覧</p>
            <AccountView
              accounts={accounts}
              selectAccount={selectAccount}
              setSelectAccount={setSelectAccount}
              addAccount={addAccount}
            />
          </div>

          {selectAccount.id !== '' && (
            <ProjectListView
              measures={measures}
              totalRows={totalRows}
              selectAccount={selectAccount}
              updateMeasures={updateMeasures(selectAccount.id)}
              addMeasure={addMeasure(selectAccount.id)}
              editMeasure={editMeasure}
            />
          )}
        </div>
      </div>
    </>
  );
};
